export class updateWageModalController {
  /* @ngInject */
  constructor ($mdDialog, $mdToast, ManageJobs, jobId, wage) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.mj = ManageJobs
    this.jobId = jobId
    this.wage = wage
    this.updatedWage = wage

    this.hasChanged = false
    this.billClient = true
  }

  detectWageChange () {
    const status = this.updatedWage - this.wage == 0 ? false : true
    this.hasChanged = status
  }

  confirm () {
    if (!this.hasChanged) {
      return this.close()
    }
    this.mj.increaseWage({ jobId: this.jobId, newWage: this.updatedWage, clientApproved: this.billClient })
      .then(() => {
        return this.mj.setJobVal(this.jobId, {wage: this.updatedWage})
      })
      .catch(() => {
        return this.$mdToast.showSimple('Unable to Modify Job Status')
      })
      .then((response) => {
        return this.$mdDialog.hide(response)
      })
  }

  close () {
    return this.$mdDialog.hide()
  }
}
  